import { render, staticRenderFns } from "./VeiculoCreateOrUpdate.vue?vue&type=template&id=60cb14ae&scoped=true&"
import script from "./VeiculoCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./VeiculoCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VeiculoCreateOrUpdate.vue?vue&type=style&index=0&id=60cb14ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb14ae",
  null
  
)

export default component.exports